// extracted by mini-css-extract-plugin
export var columnList = "_ec-0";